import React from 'react'
import { Redirect, Route } from 'react-router-dom'

const SecureRoute = ({ ability, name, ...props }) => {
  if (!ability || ability.can('read', name) || ability.can('update', name)) {
    return <Route {...props} />
  }
  return <Redirect to="/" />
}

export default SecureRoute
